/**
 * `dates` - dates in the OCR text, scored by label, time of day and recency
 * against the input's `today` (`scanReceiptText`). Best first.
 *
 * Needs `text`. Provides `candidates:purchasedAt`, each with a confidence. No
 * options.
 */

import { scanReceiptText } from '../../receipt-scan.js';
import type { Candidate, Step } from '../types.js';
import { summarize } from './support.js';

export const datesStep: Step<Record<string, never>> = {
  name: 'dates',
  needs: () => ['text'],
  provides: () => ['candidates:purchasedAt'],
  async run(state, context) {
    const { dates } = scanReceiptText(state.input.text ?? '', { today: state.input.today });
    const candidates: Candidate[] = dates.map((date) => ({ value: date.value, source: context.id, confidence: date.confidence }));
    return { candidates: { purchasedAt: candidates }, added: summarize({ purchasedAt: candidates.slice(0, 3) }) };
  },
};
